<app-products-header-banner></app-products-header-banner>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center" trackView="smartplug">
  <h2 class="font-bold text-3xl website-heading">Varroc Connect Hardware</h2>
  <span class="font-light text-2xl website-light-heading">Providing versatile device solutions</span>

  <h2 class="font-bold text-3xl website-heading mt-8">Smart Plug</h2>
  <span class="font-light text-2xl website-light-heading">Linking You To Smart Vehicles</span>
  <div class="relative w-full md:w-[30%] mt-10">
    <img [src]="Images.VC_SMARTPLUG" alt="Varroc Connect Smart Plug Device" class="w-full">
  </div>


  <div class="flex gap-1 md:gap-2 flex-wrap flex-col md:flex-row cursor-pointer mt-5 md:ms-[2.5rem]">
    <a
      href="mailto:{{SupportEmail}}?subject=Request%20to%20schedule%20a%20Demo%20for%20CarIQ%20Smart%20Plug&body=Hello%20CarIQ%20Team,%0D%0A%0AI%20am%20interested%20in%20learning%20more%20about%20the%20CarIQ%20Smart%20Plug%20and%20would%20like%20to%20schedule%20a%20demo.">
      <button class="website-button rounded-md smart_plug_ask_for_demo" (click)="onClickDemo('VC Smart Plug - Ask For Demo Clicked')">Ask For Demo</button>
    </a>

    <a
      href="mailto:{{SupportEmail}}?subject=Request%20to%20schedule%20a%20Demo%20for%20CarIQ%20Smart%20Plug&body=Hello%20CarIQ%20Team,%0D%0A%0AI%20am%20interested%20in%20learning%20more%20about%20the%20CarIQ%20Smart%20Plug%20and%20would%20like%20to%20schedule%20a%20demo.">
      <img [src]="Images.CLICK_ICON" alt="Click Icon" class="size-10 mt-5" />
    </a>
  </div>

</div>

<div class="container mx-auto mt-10 px-5 w-11/12 flex flex-col justify-center items-center gap-3">

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">Our feature-packed Smart Plugs offer a powerful vehicle
    tracking solution. They boast an IP65 rating, making them dustproof and highly water-resistant. The dongles provide
    precise motion detection and reliable GPS positioning, which are essential for tracking and for driving behaviour
    analysis. Available in various form factors to meet different requirements.</span>
  <!-- Row 1 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span><strong>Accurate GPS positioning:</strong> Enables real-time tracking of your vehicles</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span><strong>Easy installation:</strong> Simple plug-and-play functionality. It can be easily installed.</span>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span><strong>Network connectivity:</strong> Has reliable data transmission</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span><strong>Compact size:</strong> It can be easily connected into the vehicles.</span>
    </div>
  </div>

  <!-- Row 3 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span><strong>Vehicle tracking:</strong> Monitor your vehicle's location in real-time.</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="Star Icon" class="size-6">
      <span>Remote configuration and firmware update</span>
    </div>
  </div>
</div>


<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center mt-20" trackView="blackbox">
  <h2 class="font-bold text-3xl website-heading">Black Box</h2>
  <span class="font-light text-2xl website-light-heading">Reliable Tracking Solution</span>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">We offer black box that can be integrated with your
    vehicle's electrical system. These are small thus allowing for hidden installation within your vehicle. They deliver
    real-time location, allowing you to assess your vehicle's whereabouts at any given moment. Additionally, they are
    built to withstand tough conditions, ensuring reliable operation in any weather.</span>


  <div class="relative w-full md:w-[30%] mt-10">
    <img [src]="Images.VC_BLACKBOX" alt="Varroc Connect Black Box - Reliable Tracking Solution" class="w-full">
  </div>
  <div class="flex gap-1 md:gap-2 flex-wrap flex-col md:flex-row cursor-pointer mt-5 md:ms-[2.5rem]">
    <a
      href="mailto:{{SupportEmail}}?subject=Request%20to%20schedule%20a%20Demo%20for%20CarIQ%20Smart%20Plug&body=Hello%20CarIQ%20Team,%0D%0A%0AI%20am%20interested%20in%20learning%20more%20about%20the%20CarIQ%20Smart%20Plug%20and%20would%20like%20to%20schedule%20a%20demo.">
      <button class="website-button rounded-md black_box_ask_for_demo" (click)="onClickDemo('Black Box - Ask For Demo Clicked')">Ask For Demo</button>
    </a>

    <a
      href="mailto:{{SupportEmail}}?subject=Request%20to%20schedule%20a%20Demo%20for%20CarIQ%20Smart%20Plug&body=Hello%20CarIQ%20Team,%0D%0A%0AI%20am%20interested%20in%20learning%20more%20about%20the%20CarIQ%20Smart%20Plug%20and%20would%20like%20to%20schedule%20a%20demo.">
      <img [src]="Images.CLICK_ICON" alt="Click Icon" class="size-10 mt-5" />
    </a>
  </div>
</div>

<div class="container w-full mx-auto my-10 px-10 flex flex-col gap-5 md:gap-3 justify-center items-center mt-20" trackView="tcu">
  <h2 class="font-bold text-3xl website-heading">Telematics Control Unit</h2>
  <span class="font-light text-2xl website-light-heading">Packed with features for seamless connectivity</span>


  <div class="relative w-full md:w-[30%] mt-10">
    <img [src]="Images.VC_TCU" alt="Varroc Connect Telematics Control Unit (TCU)" class="w-full">
  </div>

  <div class="flex gap-1 md:gap-2 flex-wrap flex-col md:flex-row cursor-pointer mt-5">
    <a href="https://www.varroc.com/businesses/telematics-control-unit/product/telematics-control-unit" target="_blank"
      rel="noopener noreferrer" (click)="onClickDemo('Telematics control unit - Ask For Demo Clicked')">
      <button class="website-button rounded-md control_unit_more_details">More Details</button>
    </a>
  </div>

  <span class="text-l text-justify w-full mt-5 color-[#0A0A0A]">TCU (Telematics Control Unit) is used to control
    electronic automatic transmissions. It is a type of automotive ECU. These transmissions normally use sensors from
    the vehicle and also the data provided by the engine control unit (ECU), to analyse and calculate the gear changes
    in the vehicle. This analysis will be considered in giving the users optimum performance, fuel economy, and shift
    quality.</span>

  <!-- Row 1 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>GSM 4G LTE CAT1 with 2G fallback</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>BLE 5.0 for efficient device communication</span>
    </div>
  </div>

  <!-- Row 2 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>eSIM support for simplified connectivity management </span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Includes 3-axis accelerometer & gyroscope</span>
    </div>
  </div>

  <!-- Row 3 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Built-in antenna and load dump protection</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Multi-constellation GNSS (GPS, Galileo, Beidu)</span>
    </div>
  </div>

  <!-- Row 4 -->
  <div class="flex gap-6 md:flex-row flex-col mt-5 w-full">
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>IP67 compliance for durability in harsh conditions</span>
    </div>
    <div class="flex flex-1 rounded-md store-container-border p-6 shadow-md items-center gap-3">
      <img [src]="Images.STAR_ICON" alt="" class="size-6">
      <span>Scalable CAN connectivity for vehicle data exchange</span>
    </div>
  </div>

</div>